/* eslint-disable react/jsx-no-target-blank */
import {useEffect} from 'react'
import {ILayout, useLayout} from '../../core'
import { useIntl } from 'react-intl'

const Footer = () => {
  const intl = useIntl();
  const {config} = useLayout()
  useEffect(() => {
    updateDOM(config)
  }, [config])

  const companyName = process.env.REACT_APP_COMPANY_NAME
  
  return (
    <>
      <div className='text-dark order-2 order-md-1'>
        <span className='text-muted fw-semibold me-1'>
          {new Date().getFullYear().toString()}&copy;
        </span>
        <a
          href='/'
          target='_blank'
          className='text-gray-800 text-hover-primary'
        >
          {companyName}
        </a>

        <span style={{ marginLeft: '10px' }}>
          <a
            href='privacy-policy'
            target='_blank'
            className='text-gray-800 text-hover-primary'
          >
            {intl.formatMessage({ id: 'AUTH.LOGIN.PRIVACY_POLICY' })}
          </a>
        </span>
      </div>

      <ul className='menu menu-gray-600 menu-hover-primary fw-semibold order-1'></ul>
    </>
  )
}

const updateDOM = (config: ILayout) => {
  if (config.app?.footer?.fixed?.desktop) {
    document.body.classList.add('data-kt-app-footer-fixed', 'true')
  }

  if (config.app?.footer?.fixed?.mobile) {
    document.body.classList.add('data-kt-app-footer-fixed-mobile', 'true')
  }
}

export {Footer}
